export const sources = {
	avif: "__VITE_ASSET__gOpBNSELCNdnM_yZlyA5OQ__ 640w, __VITE_ASSET___ewJD0zO9$SsiDvawfmAUw__ 960w, __VITE_ASSET__K1daVVNYU_lXF$FdA5v55g__ 1280w",
	webp: "__VITE_ASSET__ZoP2ebLT5e$hm8jPkF9mgA__ 640w, __VITE_ASSET__cLZLOsSELI_GmwKcVOKKRw__ 960w, __VITE_ASSET__rN_1li4k2aIbHGs0zKW8QQ__ 1280w",
	jpeg: "__VITE_ASSET__2$LtLFQdS6IeO$uJxLxRJQ__ 640w, __VITE_ASSET__C$4kQWR6NkPB83QJdL0WCQ__ 960w, __VITE_ASSET__6MQCagmCrZzS5dHPKhXWKQ__ 1280w"
};
export const img = {
	src: "__VITE_ASSET__6MQCagmCrZzS5dHPKhXWKQ__",
	w: 1280,
	h: 720
};
export default {
	sources: sources,
	img: img
};
